"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SaleItemType = void 0;
var SaleItemType;
(function (SaleItemType) {
    SaleItemType["SERVICE"] = "Service";
    SaleItemType["PRODUCT"] = "Retail";
    SaleItemType["CONTRACT"] = "Contract";
    SaleItemType["ACCOUNTPAYMENT"] = "AccountPayment";
    SaleItemType["GIFTCARD"] = "GiftCard";
    SaleItemType["TIP"] = "Tip";
})(SaleItemType = exports.SaleItemType || (exports.SaleItemType = {}));
//# sourceMappingURL=ClientSaleTypes.js.map